import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "lists",
    name: "%{BKY_CATLISTS}",
    colour: themeWorkspace.categoryStyles.list_category.colour,
    imageName: "/toolbox-imgs/list-ol-solid.svg",
    id: "22",
    contents: [
      {
        kind: "block",
        type: "lists_create_with",
        extraState: {
          itemCount: 0,
        },
      },
      {
        kind: "block",
        type: "random_list",
        inputs: {
          length: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          callback: {
            block: {
              type: "random_number",
              fields: {
                type: "integer",
              },
              inputs: {
                min: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                max: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 100,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_create_with",
        extraState: { itemsCount: 3 },
      },
      {
        kind: "block",
        type: "lists_repeat",
        inputs: {
          NUM: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 5,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_length",
      },
      {
        kind: "block",
        type: "lists_isEmpty",
      },
      {
        kind: "block",
        type: "lists_indexOf",
        fields: {
          END: "FIRST",
        },
        inputs: {
          VALUE: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "liste",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_getIndex",
        fields: {
          MODE: "GET",
          WHERE: "FROM_START",
        },
        inputs: {
          VALUE: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_setIndex",
        fields: {
          MODE: "SET",
          WHERE: "FROM_START",
        },
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_getSublist",
        fields: {
          WHERE1: "FROM_START",
          WHERE2: "FROM_START",
        },
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_split",
        fields: {
          MODE: "SPLIT",
        },
        inputs: {
          DELIM: {
            shadow: {
              type: "text",
              fields: {
                TEXT: ",",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lists_reverse",
      },
      {
        kind: "block",
        type: "lists_sort",
        fields: {
          TYPE: "NUMERIC",
          DIRECTION: "1",
        },
      },
      {
        kind: "block",
        type: "shuffle_list",
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "delete_duplicates",
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "delete_element_from_list",
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "count_same_element_list",
        inputs: {
          ELEMENT: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 45,
              },
            },
          },
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "list_short_set",
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
          INDEX: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          VALUE: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 123,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "list_short_get",
        inputs: {
          LIST: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "list",
                  type: "",
                },
              },
            },
          },
          INDEX: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
    ],
  };
}
